var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "dynamic-vector-properties-wrapper" },
    [
      !_setup.props.disableColorMode && !_setup.props.isSolidBackground
        ? _c(_setup.CSelect, {
            staticClass: "mb-2",
            attrs: {
              options: _setup.vectorTypeOptions,
              label: "Vector type",
              "model-transform": _setup.valueReducer,
              disabled: _setup.disabled,
            },
            on: { input: _setup.updateVectorMode },
            model: {
              value: _setup.vectorMode,
              callback: function ($$v) {
                _setup.vectorMode = $$v
              },
              expression: "vectorMode",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.vectorMode || _setup.props.isSolidBackground
        ? _c(
            "section",
            { staticClass: "mt-3" },
            [
              _c(_setup.ColorOptionsClipboardButtons, {
                attrs: {
                  title: "Colors",
                  "can-copy": _setup.canCopyPasteVectorColors,
                  "can-paste": _setup.canPasteVectorColors,
                },
                on: {
                  copy: _setup.onCopyVectorColors,
                  paste: _setup.onPasteVectorColors,
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "border-bottom mt-2" }),
              _vm._v(" "),
              _c(_setup.ElementLibrarySelector, {
                staticClass: "selector-wrapper",
                attrs: {
                  disabled: _setup.disabled,
                  readonly: _vm.readonly,
                  "element-list": _setup.colors.model.colorsMap,
                  "library-id": _setup.colors.model.libraryId,
                  "library-type": _setup.COLOR_TYPE,
                  "selected-position": _setup.colors.model.option,
                  cmyk: _vm.cmykMode,
                },
                on: {
                  "option-selected": _setup.colors.onColorSelected,
                  "load-option": _setup.colors.loadColorIntoElement,
                  "options-reordered": _setup.colors.onColorOptionsReordered,
                  "remove-map-option": _setup.colors.removeColorOption,
                  "remove-library": _setup.colors.removeColorLibrary,
                  "pick-library": _setup.colors.pickColorLibrary,
                  "preview-selection": _setup.colors.previewColorOption,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }